export enum ClosePositionTabType {
  uponExpiry = "uponExpiry",
  now = "now",
}
